import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Heart, FileText, Briefcase, Scale, ArrowRight } from 'lucide-react';

const servicesData = [
  {
    icon: Heart,
    to: '/familia',
    title: 'Familia',
    subtitle: 'Divorcios, Alimentos, Cuidado Personal, Comunicación con los hijos y Filiaciones',
    description: 'Atravesar una separación es difícil. Te acompañamos a resolver convenios reguladores, planes de parentalidad, reclamación o actualización de cuotas alimentarias y filiaciones de manera ágil, priorizando el bienestar de los niños.'
  },
  {
    icon: FileText,
    to: '/sucesiones',
    title: 'Sucesiones',
    subtitle: '',
    description: 'Protegemos lo que te costó una vida construir. Llevamos adelante procesos sucesorios e inscripciones por tracto abreviado con la mayor rapidez posible, ayudándote a regularizar tus bienes familiares de forma eficiente y sin trámites eternos.'
  },
  {
    icon: Briefcase,
    to: '/laboral',
    title: 'Laboral',
    subtitle: 'Despidos, Indemnizaciones y Reclamos ante ART',
    description: 'Si sufriste un despido injustificado, trabajás de forma no registrada (en negro) o tenés diferencias salariales, defendemos tus derechos. Buscamos el reclamo correspondiente para que recibas la indemnización justa. También realizamos reclamos ante ART por accidentes y enfermedades laborales.'
  },
  {
    icon: Scale,
    to: '/accidentes-de-transito',
    title: 'Civil',
    subtitle: 'Siniestros Viales y Reclamos a Aseguradoras',
    description: 'Si tuviste un choque o un accidente en la vía pública o in itinere, nos encargamos de la negociación con las compañías de seguros para que obtengas el resarcimiento económico que te corresponde por los daños sufridos.'
  }
];

const Services = () => {
  return (
    <section className="services-section" id="servicios">
      <div className="services-container">
        <h2 className="services-title">Cómo podemos ayudarte hoy.</h2>
        <p className="services-subtitle">
          Soluciones legales pensadas para personas reales. Explicadas en tu mismo idioma.
        </p>
        <div className="services-grid">
          {servicesData.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Link key={index} to={service.to} className="service-card-link" data-testid={`service-card-link-${service.to.slice(1)}`}>
              <Card className="service-card">
                <CardHeader>
                  <div className="service-icon-wrapper">
                    <IconComponent className="service-icon" />
                  </div>
                  <CardTitle className="service-card-title">{service.title}</CardTitle>
                  {service.subtitle && (
                    <CardDescription className="service-card-subtitle">
                      {service.subtitle}
                    </CardDescription>
                  )}
                </CardHeader>
                <CardContent>
                  <p className="service-description">{service.description}</p>
                  <span className="service-more">Ver más <ArrowRight className="w-4 h-4" /></span>
                </CardContent>
              </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
